import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import * as FilePond from 'filepond'
import fr_fr from 'filepond/locale/fr-fr.js';
import { Alert } from '../functions'

const object = vnObject
const { __ } = wp.i18n

FilePond.setOptions(fr_fr);

const createPlaceForm = $('.js-create-place-form')

const mainImagePondCreation = FilePond.create(document.querySelector('.filepond-main-image-creation'), {
    acceptedFileTypes: [
        'image/jpeg',
        'image/png',
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const galleryImagesPondCretaion = FilePond.create(document.querySelector('.filepond-gallery-images-creation'), {
    acceptedFileTypes: [
        'image/jpeg',
        'image/png',
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
    allowMultiple: true,
});

if (createPlaceForm.length) {
    createPlaceForm.parsley().on('form:success', function () {
        createPlaceForm.attr('data-success', 'true')
    })

    createPlaceForm.parsley().on('form:error', function () {
        createPlaceForm.attr('data-success', 'false')
    })

    createPlaceForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()
        tinymce.triggerSave()

        const formData = new FormData(createPlaceForm[0])
        formData.append('action', 'vn_create_place')
        formData.append('nonce', object.nonce)

        var pondFiles = mainImagePondCreation.getFiles();
        if ( pondFiles[0] ) {
            formData.append('main_image', pondFiles[0].file);
        }

        var pondGalleryFiles = galleryImagesPondCretaion.getFiles();
        pondGalleryFiles.forEach((fileItem, index) => {
            formData.append('gallery_images[]', fileItem.file);
        });


        const placeSuitableFor = [];
        $('.js-place-suitable-checkbox input[type="checkbox"]:checked').each(function() {
            placeSuitableFor.push($(this).val());
        });
        formData.append('place_suitable_for', placeSuitableFor);

        const placeTypes = [];
        $('.js-place-type-checkbox input[type="checkbox"]:checked').each(function() {
            placeTypes.push($(this).val());
        });
        formData.append('place_type', placeTypes);

        const $createPlaceForm = createPlaceForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $createPlaceForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                console.log(res)
                $createPlaceForm.removeClass('sending')
                Alert(res.success, res.data.message)
                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }
                else {
                    location.reload()
                }
            },
        })
    })
}

$('.js-select-formula').on( 'click', function () {
    $('.js-price-id-input').val( $(this).data('price-id') )
    $('.js-is-premium-input').val( 0 )
    $('.js-formulas').slideUp()
    $('.js-infos').slideDown()
    if ( $(this).data('premium') ) {
        $('.js-is-premium-input').val( 1 )
        $('.js-premium-section').removeClass('not-premium')
        $('.js-premium-cta').fadeOut()
    }
})
